import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Customer } from 'server/shared/models/customer';
import { Job } from 'server/shared/models/job';
import { RoleEnum } from 'server/shared/models/role.enum';
import { User } from 'server/shared/models/user';
import {
  InviteeToggledEvent,
  JobMatchPoolerUser,
} from '../../jobs/job-edit/job-edit.types';
import { SubscriptionService } from '../subscription.service';
import { JobPossibleUserListHeaderComponent } from './job-possible-user-list-header/job-possible-user-list-header.component';
import { JobPossibleUserListItemComponent } from './job-user-list-item/job-possible-user-list-item.component';

@Component({
  selector: 'app-job-possible-users-list',
  templateUrl: 'job-possible-users-list.component.html',
  styleUrls: ['job-possible-users-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobPossibleUsersListComponent implements OnDestroy {
  private destroyed$ = new Subject<void>();

  @Input() directAcceptedUsers: JobMatchPoolerUser[] = [];
  get directAcceptedUserIds() {
    return this.directAcceptedUsers.map((user) => user._id);
  }
  @Input() directInvitedUsers: JobMatchPoolerUser[] = [];
  get directInvitedUserIds() {
    return this.directInvitedUsers.map((user) => user._id);
  }

  @Input() collection?: JobMatchPoolerUser[];
  @Input() job?: Job;
  @Input() jobDate?: string;
  @Input() randomId?: string;
  @Input() jobCount?: number;
  @Input() userCount?: Map<string, number>;
  @Input() loadingCollection: boolean = false;
  @Input() jobInPast: boolean = false;
  @Input() jobCustomer?: Customer;
  @Input() loggedInCustomer?: Customer;
  public isLoading$ = new BehaviorSubject<boolean>(true);

  roleEnum = RoleEnum;

  @Input() suggestInsteadDirectAccept = false;

  @Output() inviteeToggled = new EventEmitter<InviteeToggledEvent>();
  @Output() selectAllToggled = new EventEmitter<boolean>();

  @ViewChildren('userListItem')
  userListItems!: QueryList<JobPossibleUserListItemComponent>;
  @ViewChild('userListHeader', { static: false })
  userListHeader?: JobPossibleUserListHeaderComponent;

  constructor(
    private ngZone: NgZone,
    private subscriptionService: SubscriptionService,
  ) {}

  ngOnInit() {
    this.isLoading$.next(true);
    this.subscriptionService.jobUsersReady$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.ngZone.run(() => {
          this.isLoading$.next(false);
        });
      });
  }

  trackUser(index: number, item: User) {
    return item._id;
  }

  toggleInviteAll(selected: boolean) {
    this.selectAllToggled.emit(selected);
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
